/*
  /!\ WARNING /!\

  This is NOT a regular index for the actions contained in this folder! It is the compatibility layer for the OLD flux-based actions which used to live in actions.js!

  It lives here only for backwards compatibility reasons and will be removed at the first opportunity!
 */

import {globalBuildContext} from 'rlink-router/__globalBuildContextForLegacySupport__';
import navTo from 'rlink-router/actions/navTo';
import openModal from 'rlink-router/actions/openModal';
import openFlyout from 'rlink-router/actions/openFlyout';
import externalNavTo from 'rlink-router/actions/externalNavTo';

export default {
  NavTo ({view, params, transition, returnTransition, afterLoad, afterNav, scrollTo = [0, 0], pushToHistory = true, modal, replace, flyout}) {
    if (afterLoad || afterNav) {
      throw new Error('afterLoad and afterNav arguments for NavTo are no longer supported!');
      // if this actually a problem, just use setTimeout for now or something
    }

    if (modal
      && (!replace || globalBuildContext.reduxStore.getState().routing.modals.length > 0)) {
      return globalBuildContext.reduxStore.dispatch(
        openModal({
          buildContext: globalBuildContext,
          view, params, replace,
        }));
    } else if (flyout) {
      return globalBuildContext.reduxStore.dispatch(
        openFlyout({
          buildContext: globalBuildContext,
          view, params, name: flyout,
        }));
    } else {
      return globalBuildContext.reduxStore.dispatch(navTo(globalBuildContext, {
        view, params,
        scrollTo,
        transition,
        returnTransition,
        replaceNavStates: !pushToHistory,
      }));
    }
  },
  ExternalNavTo ({url, params}) {
    globalBuildContext.reduxStore.dispatch(externalNavTo({url, params}));
  },
};



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/index.js